import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import classNames from 'classnames'
import { injectIntl, FormattedMessage } from 'react-intl'
import HighlightedTextarea from './HighlightedTextarea'
import { charCountLimit } from './index'
import { checkIfEmpty } from '../../services/helpers'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import { updateEditDynamicDataState } from '../../actions/AspireEditDynamicData'
import { updateNewSamplesState } from '../../actions/AspireSamples'
import Loader from '../Loader'
import {
  fetchResumeGap,
  updateResumeGapState,
} from '../../actions/AspireResumeGap'
import { editModalAriaLabel } from '../Constants/AriaLabelText'
import ThreeDotsButton from './HelperComponents/ThreeDotsButton'
import SaveBtn from './HelperComponents/SaveBtn'
class Summary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedModule: 'samples',
      selectedSkill: '',
      selectedPresentCategory: '',
      focused: {
        text: false,
      },
      checkbox: {
        tense: false,
        narrative_voice: false,
        buzzwords: false,
        verb_overusage: false,
        action_oriented: false,
        specifics: false,
      },
      iimmumbaiExampleIndex: 0,
    }
    this.moduleIconsMapping = {
      skills: 'dist/images/edit-screens/skills-icon.svg',
      content: 'dist/images/edit-screens/content-icon.svg',
      language: 'dist/images/edit-screens/language-icon.svg',
      impact: 'dist/images/edit-screens/impact-icon.svg',
      samples: 'dist/images/edit-screens/samples-icon.svg',
      rephrase_words: 'dist/images/edit-screens/rephrase-words-icon.svg',
    }
    this.displayNameMapping = {
      skills: this.props.intl.formatMessage({
        id: 'aspire.summary.skills',
        defaultMessage: 'Skills',
      }),
      content: this.props.intl.formatMessage({
        id: 'aspire.summary.content',
        defaultMessage: 'Content',
      }),
      language: this.props.intl.formatMessage({
        id: 'aspire.summary.language',
        defaultMessage: 'Language',
      }),
      impact: this.props.intl.formatMessage({
        id: 'aspire.summary.impact',
        defaultMessage: 'Impact',
      }),
      samples: this.props.intl.formatMessage({
        id: 'aspire.summary.samples',
        defaultMessage: 'Samples',
      }),
      rephrase_words: this.props.intl.formatMessage({
        id: 'aspire.summary.wordUsage',
        defaultMessage: 'Word Usage',
      }),
    }
    this.modulesPresent = []
    this.getFeedbackNav = this.getFeedbackNav.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.updateCheckboxState = this.updateCheckboxState.bind(this)
    this.handleUndoClick = this.handleUndoClick.bind(this)
    this.sendTrackingDebounce = _.debounce(sendTrackingData, 1000, true)
    this.sendTrackingDataDebounceUndo = _.debounce(sendTrackingData, 3000, true)
    this.summaryCharsRemaining = charCountLimit['summary']['text']
    this.highlightValues = this.highlightValues.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleCloseButton = this.handleCloseButton.bind(this)
    this.setSelectedSkill = this.setSelectedSkill.bind(this)
    this.setSelectedPresentCategory = this.setSelectedPresentCategory.bind(this)
    this.loadLeftNavBar = this.loadLeftNavBar.bind(this)
    this.handleModuleClick = this.handleModuleClick.bind(this)
    this.placeholders = {
      text: this.props.intl.formatMessage({
        id: 'aspire.summary.placeholderText',
        defaultMessage: 'Enter summary',
      }),
    }
  }

  UNSAFE_componentWillMount() {
    const {
      sectionWiseTextEditable,
      currentIndex,
      fetchResumeGap,
      fetchId,
      hasResume,
      newSubSection,
      feedback,
    } = this.props

    let text = ''
    if (sectionWiseTextEditable[currentIndex]['text'] !== 'N/A') {
      text = sectionWiseTextEditable[currentIndex]['text']
    }
    this.summaryCharsRemaining = charCountLimit['summary']['text'] - text.length

    if (hasResume == 1) {
      if (newSubSection == true) {
        fetchResumeGap(fetchId, 'Summary', -1)
      } else {
        fetchResumeGap(fetchId, 'Summary', currentIndex)
      }
    }
    this.loadLeftNavBar(newSubSection, feedback)
  }

  componentWillUnmount() {
    const {
      currentIndex,
      hideEditModal,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
    } = this.props
  }

  loadLeftNavBar(newSubSection, feedback) {
    if (newSubSection) {
      this.modulesPresentList = [
        'samples',
        'content',
        'skills',
        'language',
        'impact',
        'rephrase_words',
      ]
    } else {
      this.modulesPresentList = ['samples']
      if (
        !_.isUndefined(feedback['categories']) &&
        !_.isEmpty(feedback['categories']) &&
        feedback['categories'].hasOwnProperty('categories')
      ) {
        this.modulesPresentList.push('content')
      }
      if (
        !_.isUndefined(feedback['skills']) &&
        !_.isEmpty(feedback['skills'])
      ) {
        this.modulesPresentList.push('skills')
      }
      if (
        !_.isUndefined(feedback['language']) &&
        !_.isEmpty(feedback['language']) &&
        (feedback['language'].hasOwnProperty('tense') ||
          feedback['language'].hasOwnProperty('narrative_voice'))
      ) {
        this.modulesPresentList.push('language')
      }
      if (
        !_.isUndefined(feedback['impact']) &&
        !_.isEmpty(feedback['impact'])
      ) {
        this.modulesPresentList.push('impact')
      }
      if (
        !_.isUndefined(feedback['language']) &&
        !_.isEmpty(feedback['language']) &&
        (feedback['language'].hasOwnProperty('verb_overusage') ||
          feedback['language'].hasOwnProperty('buzzwords'))
      ) {
        this.modulesPresentList.push('rephrase_words')
      }
    }

    let isCurrentSelectedModulePresentInNewFeedback = _.indexOf(
      this.modulesPresentList,
      this.state.selectedModule
    )

    if (isCurrentSelectedModulePresentInNewFeedback == -1) {
      this.setState({ selectedModule: 'samples' })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { feedback, newSubSection } = nextProps

    this.loadLeftNavBar(newSubSection, feedback)
  }

  setSelectedSkill(skill) {
    this.setState({ selectedSkill: skill })
  }

  setSelectedPresentCategory(category) {
    this.setState({ selectedPresentCategory: category })
  }


  handleModuleClick(module) {
    const { currentIndex } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'module_click',
      currentSection: 'Summary',
      currentIndex: currentIndex,
      module: module,
    }
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.setState({ selectedModule: module })
  }

  getFeedbackNav() {
    const { intl } = this.props
    let links = _.map(
      this.modulesPresentList,
      function (module) {
        let isActive = false
        if (this.state.selectedModule == module) {
          isActive = true
        }
        let moduleDisplayName = this.displayNameMapping[module]
        let moduleIcon = this.moduleIconsMapping[module]

        return (
          <div key={module}>
            <a
              tabIndex={0}
              aria-label={editModalAriaLabel(intl)[module]}
              href="javascript:void(0);"
              aria-selected={isActive}
              className={classNames('as-nav-list-item', { active: isActive })}
              onClick={() => this.handleModuleClick(module)}>
              <div className="as-nav-list-item-icon">
                <img src={`${process.env.APP_BASE_URL + moduleIcon}`} alt="" />
              </div>
              <div className="as-nav-list-item-text">{moduleDisplayName}</div>
            </a>
          </div>
        )
      },
      this
    )

    return <div className="as-edit-feedback-nav as-shadow">{links}</div>
  }

  handleChange(e) {
    const value = e.target.value
    this.props.handleOnChangeData(
      'summary',
      this.props.currentIndex,
      'text',
      value
    )
    let charsRemainingCount = -1
    if (
      charCountLimit.hasOwnProperty('summary') &&
      charCountLimit['summary'].hasOwnProperty('text')
    ) {
      charsRemainingCount = charCountLimit['summary']['text'] - value.length
    }
    // if(charsRemainingCount < 0){
    //   charsRemainingCount = 0
    // }
    this.summaryCharsRemaining = charsRemainingCount
  }

  handleUndoClick() {
    const { currentIndex, sectionWiseTextStatic } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'undo_changes_btn',
      currentSection: 'Summary',
      currentIndex: currentIndex,
    }
    this.sendTrackingDataDebounceUndo(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    this.props.handleUndoData('summary', currentIndex)
    let text = ''
    if (sectionWiseTextStatic[currentIndex]['text'] !== 'N/A') {
      text = sectionWiseTextStatic[currentIndex]['text']
    }
    this.summaryCharsRemaining = charCountLimit['summary']['text'] - text.length
  }

  handleFocus(field, e) {
    e.preventDefault()
    const { unhighlightAll } = this.props
    unhighlightAll()
    let focused = this.state.focused
    for (let i in focused) {
      if (i == field) {
        focused[i] = true
      } else {
        focused[i] = false
      }
    }
    let checkbox = {
      tense: false,
      narrative_voice: false,
      buzzwords: false,
      verb_overusage: false,
      action_oriented: false,
      specifics: false,
    }
    this.setState({
      focused: focused,
      checkbox: checkbox,
      selectedSkill: '',
      selectedPresentCategory: '',
    })
  }

  handleBlur(field) {
    let focused = this.state.focused
    focused[field] = false
    this.setState({ focused: focused })
  }

  highlightValues(input) {
    return this.props.highlightableDivWords
  }

  renderEntityText(entity) {
    const { savingChanges, intl } = this.props

    let fieldDisabled = false
    if (savingChanges) {
      fieldDisabled = true
    }

    let text = ''
    if (
      this.props.sectionWiseTextEditable[this.props.currentIndex]['text'] !==
      'N/A'
    ) {
      text = this.props.sectionWiseTextEditable[this.props.currentIndex]['text']
    }


    return (
      <div className="edit-summary max-tall">
        <HighlightedTextarea
          autoFocus={true}
          name={'text'}
          highlight={this.highlightValues}
          value={text}
          placeholder={this.placeholders['text']}
          onFocus={(e) => this.handleFocus('text', e)}
          onBlur={() => this.handleBlur('text')}
          onChange={this.handleChange}
          disabled={fieldDisabled}
        />
        <span className="summary-chars-remain description">
          <span>
            <FormattedMessage
              id="aspire.summary.characterCountNote"
              defaultMessage="The character count is maintained in accordance with LinkedIn guidelines"
            />
          </span>
        </span>
        <span className="summary-chars-remain">
          <span>
            {charCountLimit['summary']['text'] - this.summaryCharsRemaining}
          </span>
          /{charCountLimit['summary']['text']}
        </span>
      </div>
    )
  }

  renderPlaceholder(text, field) {
    if (!_.isEmpty(text)) {
      return text.split('\n').map(function (v) {
        if (!v.match(/[a-z0-9]/i)) {
          return <br />
        }
        return <div>{v}</div>
      })
    }
    return <span className="placeholder-color">{this.placeholders[field]}</span>
  }

  updateCheckboxState(checkbox) {
    this.setState({ checkbox: checkbox })
  }

  handleCloseButton() {
    const {
      handleUndoData,
      currentIndex,
      hideEditModal,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
      intl,
    } = this.props
    let jsonObjectForTracking = {
      eventLabel: 'close_btn',
      currentSection: 'Summary',
      currentIndex: currentIndex,
    }
    sendTrackingData(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    hideEditModal(
      'summary',
      currentIndex,
      sectionWiseTextEditable,
      sectionWiseTextStatic
    )
  }

  getLabel(field, heading, emptyCondition) {
    const { savingChanges } = this.props
    let colorClass = null
    if (_.isEmpty(emptyCondition)) {
      colorClass = 'as-edit-input-field-label text-red'
    } else if (savingChanges) {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    } else if (this.state.focused[field]) {
      colorClass = 'as-edit-input-field-label as-focused-label-text-color'
    } else {
      colorClass = 'as-edit-input-field-label as-label-text-color'
    }

    return (
      <label htmlFor={field} className={colorClass}>
        {heading} <span className="text-red">*</span>
      </label>
    )
  }

  getStaticSuggestion() {
    const { intl, user } = this.props;
    const { community } = user || {};
    if ( community === 'mofo' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.about.writingTipsHeadlineMofo" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.about.writingTipsTextMofo" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.about.tipsToGetStartedHeadlineMofo" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.about.tipsToGetStartedTextMofo" }),
        exampleHeadline: intl.formatMessage({ id: "staticSuggestion.about.exampleHeadlineMofo" }),
        exampleText: intl.formatMessage({ id: "staticSuggestion.about.exampleTextMofo" })
      };
    }
    if ( community === 'iimmumbai' ) {
      return {
        writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.about.writingTipsHeadlineIIMMumbai" }),
        writingTipsText: intl.formatMessage({ id: "staticSuggestion.about.writingTipsTextIIMMumbai" }),
        tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.about.tipsToGetStartedHeadlineIIMMumbai" }),
        tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.about.tipsToGetStartedTextIIMMumbai" }),
        examples: [
          { headline: intl.formatMessage({ id: "staticSuggestion.about.exampleHeadline1IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.about.exampleText1IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.about.exampleHeadline2IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.about.exampleText2IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.about.exampleHeadline3IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.about.exampleText3IIMMumbai" }) },
          { headline: intl.formatMessage({ id: "staticSuggestion.about.exampleHeadline4IIMMumbai" }), text: intl.formatMessage({ id: "staticSuggestion.about.exampleText4IIMMumbai" }) },
        ],
      };
    }
    return {
      writingTipsHeadline: intl.formatMessage({ id: "staticSuggestion.about.writingTipsHeadline" }),
      writingTipsText: intl.formatMessage({ id: "staticSuggestion.about.writingTipsText" }),
      tipsToGetStartedHeadline: intl.formatMessage({ id: "staticSuggestion.about.tipsToGetStartedHeadline" }),
      tipsToGetStartedText: intl.formatMessage({ id: "staticSuggestion.about.tipsToGetStartedText" }),
      exampleHeadline: intl.formatMessage({ id: "staticSuggestion.about.exampleHeadline" }),
      exampleText: intl.formatMessage({ id: "staticSuggestion.about.exampleText" })
    };
  }

  render() {
    const {
      savingChanges,
      currentIndex,
      sectionWiseTextStatic,
      sectionWiseTextEditable,
      showLogModal,
      newSubSection,
      handleSaveChanges,
      intl,
      isRightNavToggle,
    } = this.props

    let undoButton = null
    let saveDisabled = true
    if (
      !(
        JSON.stringify(sectionWiseTextEditable[currentIndex]) ===
          JSON.stringify(sectionWiseTextStatic[currentIndex]) || savingChanges
      )
    ) {
      saveDisabled = false
      undoButton = (
        <button
          tabIndex={0}
          aria-label={editModalAriaLabel(intl)['reset']}
          className="btn btn-undo-changes"
          onClick={this.handleUndoClick}
          onMouseDown={this.handleUndoClick}>
          <FormattedMessage
            id="aspire.summary.resetButton"
            defaultMessage="Reset"
          />
        </button>
      )
    }

    let saveButton = (
      <SaveBtn
        savingChanges={savingChanges}
        saveDisabled={saveDisabled}
        handleSaveChanges={handleSaveChanges}
        intl={intl}
      />
    )

    let editOrAdd =
      !_.isUndefined(currentIndex) &&
      _.isString(currentIndex) &&
      currentIndex.substr(-4) === '_new'
        ? 'Add'
        : 'Edit'

    // calculation for focused state and black overlay
    let text = ''
    if (
      this.props.sectionWiseTextEditable[this.props.currentIndex]['text'] !==
      'N/A'
    ) {
      text = this.props.sectionWiseTextEditable[this.props.currentIndex]['text']
    }

    let summaryLength = 0
    if (text != '') {
      summaryLength = text.length
    }

    let blackOverlayClass = ''
    let editFocusedClass = ''

    if (savingChanges) {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
      $('.edit-summary .hwt-content').css('font-size', '16px')
      $('.edit-summary .hwt-content').css('line-height', '24px')
    } else if (this.state.focused.text) {
      blackOverlayClass = 'as-edit-overlay-none as-edit-overlay-black'
      if (summaryLength >= 300) {
        editFocusedClass = 'as-edit-focused-none as-edit-focused-black'
        $('.edit-summary .hwt-content').css('font-size', '16px')
        $('.edit-summary .hwt-content').css('line-height', '24px')
      } else {
        editFocusedClass = 'as-edit-focused-none as-edit-focused-black'
        $('.edit-summary .hwt-content').css('font-size', '16px')
        $('.edit-summary .hwt-content').css('line-height', '24px')
      }
    } else {
      blackOverlayClass = 'as-edit-overlay-none'
      editFocusedClass = 'as-edit-focused-none'
      $('.edit-summary .hwt-content').css('font-size', '16px')
      $('.edit-summary .hwt-content').css('line-height', '24px')
    }

    let threeDotsBtn = (
      <ThreeDotsButton showLogModal={showLogModal} section="Summary" />
    )

    if (newSubSection) {
      undoButton = null
      threeDotsBtn = null
    }

    const summaryTips = this.getStaticSuggestion();

    return (
      <div className="as-edit-wrapper scroll-hidden">
        <Loader sectionName="Summary" />
        <div className="as-edit-close-div">
          <a
            href="javascript:void(0);"
            aria-label={editModalAriaLabel(intl)['close']}
            onClick={this.handleCloseButton}
            className="icon-cross as-edit-close-btn modal-close-button"
            style={!isRightNavToggle ? { right: '17%' } : {}}
          />
        </div>
        <div className="as-edit-heading-wrapper">
          <div className="as-edit-heading" role="heading" aria-level="3">
            <FormattedMessage
              id="aspire.summary.heading"
              defaultMessage="About"
            />
          </div>
          <div className="as-edit-actions-div">
            <div className="as-edit-action-undo">{undoButton}</div>
            <div className="as-edit-action-save">{saveButton}</div>
            {threeDotsBtn}
          </div>
        </div>
        <div className="as-edit-container as-summary-container vertical-scroll">
          <div className={editFocusedClass}>
            <div className="as-edit-inputs-row-headline">
              <div className="as-edit-inputs-col-headline max-tall">
                {this.renderEntityText('text')}
              </div>
            </div>
          </div>
        </div>
        <div className="as-edit-info-div">
          <div className="as-edit-suggestions-heading">
            <div>
              {summaryTips.writingTipsHeadline}
            </div>
          </div>
          <div className="as-edit-card-headline-education">
            {
              <div className="tips-section">
                <div style={{ whiteSpace: 'pre-line' }}>{summaryTips.writingTipsText}</div>
                <div className="tips-heading">{summaryTips.tipsToGetStartedHeadline}</div>
                <div style={{ whiteSpace: 'pre-line' }}>{summaryTips.tipsToGetStartedText}</div>
                {!summaryTips.examples ? (
                  <div>
                    <div className="tips-heading">{summaryTips.exampleHeadline}</div>
                    <div style={{ whiteSpace: 'pre-line' }}>{summaryTips.exampleText}</div>
                  </div>
                ) : null}
              </div>
            }
            {summaryTips.examples ? (
              <div className="sample-carousel-wrapper">
                <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === 0} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex - 1 })} className="sample-carousel-btn sample-carousel-btn-prev">
                  <span className="arrow arrow-left" />
                </button>
                <div className="sample-carousel-card">
                  <div className="tips-heading">
                    {'Sample ' + (this.state.iimmumbaiExampleIndex + 1) + ' of ' + summaryTips.examples.length + ' › ' + summaryTips.examples[this.state.iimmumbaiExampleIndex].headline}
                  </div>
                  <div style={{ whiteSpace: 'pre-line' }}>{summaryTips.examples[this.state.iimmumbaiExampleIndex].text}</div>
                </div>
                <button tabIndex={0} disabled={this.state.iimmumbaiExampleIndex === summaryTips.examples.length - 1} onClick={() => this.setState({ iimmumbaiExampleIndex: this.state.iimmumbaiExampleIndex + 1 })} className="sample-carousel-btn sample-carousel-btn-next">
                  <span className="arrow arrow-right" />
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const { underlineEntitySpellError } = this.props
    underlineEntitySpellError()
  }

  componentDidMount() {}

  componentWillUnmount() {
    const {
      updateEditDynamicDataState,
      updateNewSamplesState,
      updateResumeGapState,
    } = this.props
    updateEditDynamicDataState({
      updateKeys: [
        ['fetchedContent'],
        ['fetchingContent'],
        ['dataContent'],
        ['errorContent'],
        ['fetchedSkills'],
        ['fetchingSkills'],
        ['dataSkills'],
        ['errorSkills'],
        ['fetchedLanguage'],
        ['fetchingLanguage'],
        ['dataLanguage'],
        ['errorLanguage'],
        ['fetchedImpact'],
        ['fetchingImpact'],
        ['dataImpact'],
        ['errorImpact'],
        ['fetchedRephraseWords'],
        ['fetchingRephraseWords'],
        ['dataRephraseWords'],
        ['errorRephraseWords'],
        ['sectionWiseTextIntermediateContent'],
        ['sectionWiseTextIntermediateSkills'],
        ['sectionWiseTextIntermediateImpact'],
        ['sectionWiseTextIntermediateRephraseWords'],
      ],
      data: {
        fetchedContent: false,
        fetchingContent: false,
        dataContent: null,
        errorContent: false,
        fetchedSkills: false,
        fetchingSkills: false,
        dataSkills: null,
        errorSkills: false,
        fetchedLanguage: false,
        fetchingLanguage: false,
        dataLanguage: null,
        errorLanguage: false,
        fetchedImpact: false,
        fetchingImpact: false,
        dataImpact: null,
        errorImpact: false,
        fetchedRephraseWords: false,
        fetchingRephraseWords: false,
        dataRephraseWords: null,
        errorRephraseWords: false,
        sectionWiseTextIntermediateContent: null,
        sectionWiseTextIntermediateSkills: null,
        sectionWiseTextIntermediateImpact: null,
        sectionWiseTextIntermediateRephraseWords: null,
      },
    })
    updateNewSamplesState({
      updateKeys: [['fetched'], ['fetching'], ['samples'], ['error']],
      data: { fetched: false, fetching: false, samples: null, error: false },
    })
    updateResumeGapState({
      updateKeys: [['fetched'], ['fetching'], ['data'], ['error']],
      data: { fetched: false, fetching: false, data: null, error: null },
    })
  }
}

function mapStateToProps(state, ownProps) {
  return {
    savingChanges:
      !_.isEmpty(state.aspireFeedbackData.mini_loader_text) ||
      ownProps.uploadingEditedData,
    hasResume: state.aspireFeedbackData.has_resume,
    loaderInput: state.aspireFeedbackData.mini_loader_text,
    processedModulesCount: state.aspireFeedbackData.processed_modules_count,
    isRightNavToggle: state.editData.isRightNavToggle,
    user: state.user.data,
  }
}

export default connect(mapStateToProps, {
  updateEditDynamicDataState,
  updateNewSamplesState,
  updateResumeGapState,
  fetchResumeGap,
})(injectIntl(Summary))
